import { createAction } from 'redux-actions'

const ENTITY = 'AUTH'
export const stateKey = ENTITY.toLowerCase()

export const authenticateInitial = createAction(`${ENTITY}/INITIAL`)
export const authenticateSuccess = createAction(`${ENTITY}/SUCCESS`)
export const authenticateFailure = createAction(`${ENTITY}/FAILURE`)
export const authenticateDestroy = createAction(`${ENTITY}/DESTROY`)
export const resetPasswordSuccess = createAction(`${ENTITY}/RESET_PASSWORD/SUCCESS`)
